import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'



// 创建 store 实例
export default new Vuex.Store({
  getters,
  actions,
  mutations,
  state
})



// WEBPACK FOOTER //
// ./src/store/index.js